import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import React, { FC, ReactElement } from 'react';
import { Error } from 'src/components/Error';
import { NoResults } from '../../../components/no-results';
import { IShipTo, ISoldTo } from '../../../graphql/types';

export const GET_SOLD_TO_BY_ID = gql`
  query GetSoldToByID($id: String!) {
    soldTo(id: $id) {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
    }
  }
`;

export const GET_SHIP_TO_BY_ID = gql`
  query GetShipToById($id: String!) {
    shipTo(id: $id) {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
      smhActiveUser
      vmiIndicator
    }
  }
`;

interface IGetSoldToByIdQueryProps {
  soldToId: string;
  shipToId?: string;
  render: (soldTo: ISoldTo, shipTo?: IShipTo) => ReactElement;
}

const GetSoldToShipToByIdQuery: FC<IGetSoldToByIdQueryProps> = ({
  soldToId,
  shipToId,
  render,
}) => {
  const soldTo = useQuery(GET_SOLD_TO_BY_ID, {
    variables: {
      id: soldToId,
    },
  });

  const shipTo = useQuery(GET_SHIP_TO_BY_ID, {
    skip: !shipToId,
    variables: {
      id: shipToId,
    },
  });

  if (soldTo.loading) {
    // no point showing a loader - this is normally fast enough
    return null;
  } else if (soldTo.error || shipTo.error) {
    return <Error />;
  } else if (!soldTo.data || !soldTo.data.soldTo) {
    return <NoResults />;
  }
  return render(soldTo.data.soldTo, (shipTo.data || {}).shipTo);
};

export { GetSoldToShipToByIdQuery };
